class MutualTransferAgreementService {
  constructor({ axios }) {
    this.axios = axios;
    this.url = '/api/document/mutual-transfer-agreements';
  }

  async getList({ query = '', dates = [] } = {}) {
    const result = await this.axios.get(this.url, {
      params: {
        query,
        ...(Object.keys(dates).length > 0 && dates),
      },
    });
    const { data } = result;
    return data;
  }

  async getOne({ id }) {
    const { data } = await this.axios.get(`${this.url}/${id}`);
    return data;
  }

  async create({ mutualTransferAgreement }) {
    const { data } = await this.axios.post(this.url, mutualTransferAgreement);
    return data;
  }

  async upload({ id, formData }) {
    const { data } = await this.axios.put(`${this.url}/upload/${id}`, formData);
    return data;
  }

  async update({ mutualTransferAgreement }) {
    const { data } = await this.axios.put(this.url, mutualTransferAgreement);
    return data;
  }

  async archive({ mutualTransferAgreement }) {
    const { _id: id } = mutualTransferAgreement;
    const { data } = await this.axios.delete(`${this.url}/archive/${id}`, { data: mutualTransferAgreement });
    return data;
  }
}

export default MutualTransferAgreementService;
